import { render, staticRenderFns } from "./form-location.vue?vue&type=template&id=3c9b31c3"
import script from "./form-location.vue?vue&type=script&lang=js"
export * from "./form-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports